var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisableSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#ADADAD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2583 12.0037C27.4798 12.0037 27.6977 12.0074 27.9192 12C27.9859 12 28 12.0184 28 12.0847C27.9965 12.3387 28 12.5927 28 12.8504C27.9121 13.4505 27.8207 14.0469 27.7329 14.6469C27.4446 16.6717 27.1634 18.6965 26.8752 20.7213C26.5729 22.8491 26.2707 24.977 25.9684 27.1048C25.8946 27.6165 25.5677 27.8374 25.1002 27.6681C22.594 26.7735 20.0914 25.8752 17.5888 24.9806C17.3076 24.8812 17.2689 24.9181 17.4974 24.6272C19.8699 21.6269 22.246 18.6265 24.6186 15.6299C24.6573 15.582 24.6924 15.5342 24.7276 15.4863C24.6643 15.4937 24.6292 15.5231 24.594 15.5562C21.4728 18.3504 18.3515 21.1446 15.2337 23.9425C15.1213 24.0419 15.0264 24.0677 14.8858 24.0161C13.4235 23.486 11.9649 22.9632 10.4991 22.4442C10.2742 22.3632 10.1019 22.2417 10 22.0171C10 21.8809 10 21.7484 10 21.6122C10.1125 21.3581 10.3409 21.2514 10.5589 21.1336C14.3726 19.0499 18.1863 16.9625 21.9965 14.8789C23.7504 13.918 25.5044 12.9608 27.2583 12.0037Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0622 28.9975C15.8219 28.9185 15.7248 28.7428 15.7273 28.5009C15.7273 27.742 15.7273 26.9832 15.7273 26.2243C15.7273 26.0537 15.7427 26.0435 15.9012 26.0995C16.5505 26.3185 17.1972 26.5401 17.844 26.7616C17.9794 26.8075 17.982 26.8177 17.8976 26.9322C17.4426 27.551 16.985 28.1673 16.53 28.7886C16.4584 28.8854 16.3715 28.9516 16.2641 29C16.1977 28.9975 16.1312 28.9975 16.0622 28.9975Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisableSend);
export default __webpack_public_path__ + "static/media/disable-send.2c541691b24f8a15a4c2aa42a9402aae.svg";
export { ForwardRef as ReactComponent };